/**
 * Hash a PIN using SHA-256 via the Web Crypto API.
 * Returns a hex string. Used client-side before storing or comparing PINs.
 */
export async function hashPin(pin) {
  const encoder = new TextEncoder();
  const data     = encoder.encode(String(pin).trim());
  const hashBuf  = await crypto.subtle.digest('SHA-256', data);
  const hashArr  = Array.from(new Uint8Array(hashBuf));
  return hashArr.map((b) => b.toString(16).padStart(2, '0')).join('');
}
